import { Axios } from "./axiosInstance.js";
import configSettings from './../config.js';

export const vendorDraftProductsService = () => {
   const baseUrl = configSettings.vendorPortalBaseUrl;

    return Axios.createInstanceWithApiKey().get(
      `${baseUrl}VendorProducts/Getproductslist`
    );

}
